import type { Dict } from '../ru';
import { admin } from './admin';
import { app } from './app';
import { auth } from './auth';
import { common } from './common';
import { lobby } from './lobby';
import { profile } from './profile';
import { srv } from './srv';
import { table } from './table';
import { verify } from './verify';

export const de: Dict = { common, app, auth, lobby, table, profile, admin, verify, srv };
